import { render, staticRenderFns } from "./AMT.vue?vue&type=template&id=e880d2b8&scoped=true"
import script from "./AMT.vue?vue&type=script&lang=js"
export * from "./AMT.vue?vue&type=script&lang=js"
import style0 from "./AMT.vue?vue&type=style&index=0&id=e880d2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e880d2b8",
  null
  
)

export default component.exports